export class Request {

	public url: string;

	constructor(url: string) {

		this.url = url;
	}
}
